import React from 'react';

import { useTranslation } from 'react-i18next';

import { type ExpireOption, useExpireTimestamp } from '@pkg/hooks';

import { DateLabel, Option, StyledItem } from './Menu.style';

export interface ItemProps {
    expiration: ExpireOption;
    disabled?: boolean;
    pressed?: boolean;
    onSelect: (option: ExpireOption, expiryDate?: string) => void;
}

export function Item({ expiration, disabled = false, pressed = false, onSelect }: ItemProps) {
    const [translate] = useTranslation('marketplace');
    const { expireLabel, expireDate } = useExpireTimestamp(expiration);
    return (
        <StyledItem>
            <Option
                aria-label={translate('common-expire-option-a11y')}
                aria-pressed={pressed ? true : undefined}
                disabled={disabled}
                onClick={() => onSelect(expiration, expireDate)}
            >
                <DateLabel>{expireLabel}</DateLabel>
            </Option>
        </StyledItem>
    );
}
